import branch from "../assets/icons/branch.png";
import live from "../assets/icons/live.png";
import dashboard from "../assets/icons/dashboard.png";
import product from "../assets/icons/products.png";
import order from "../assets/icons/orders.png";
import customer from "../assets/icons/customer-data.png";
import notification from "../assets/icons/notification.png";
import brand from "../assets/icons/branding.png";
import socialMedia from "../assets/icons/social-media.png";
import Qr from "../assets/icons/qr-code.png";
import documents from "../assets/icons/Documents.png";
import waiter from "../assets/icons/waiter.png";
export const data = {
  Superadmin: [
    {
      name: "Dashboard",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={dashboard}
        ></img>
      ),
      route: "/dashboard",
    },
    {
      name: "Live Orders",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={live}
        ></img>
      ),
      route: "/liveorders",
    },
    {
      isMulti: true,
      name: "Branch",
      children: [
        { name: "Add Branch", route: "/branch/add/basic" },
        { name: "View Branch", route: "/view/branch" },
        { name: "Branch Bulk Upload", route: "/branch/bulk/upload" },
      ],
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={branch}
        ></img>
      ),
    },
    {
      name: "Waiter Pannel",
      icon: <img></img>,
      route: "/waiter/pannel/signup",
    },
    {
      name: "Products",
      children: [
        { name: "New Products", route: "/item/add" },
        { name: "View Products", route: "/view/menu" },
        { name: "Combo's", route: "/combo" },
        { name: "View Combo", route: "/view/combo" },
        { name: "Discount", route: "/discount" },
        { name: "View Discounts", route: "/view/discount" },
        { name: "Product Bulk upload", route: "/product/bulk/upload" },
      ],
      isMulti: true,
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={product}
        ></img>
      ),
    },
    {
      name: "Qr",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={Qr}
        ></img>
      ),
      route: "/qr",
    },
    {
      name: "Order History",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={order}
        ></img>
      ),
      route: "/order-history",
    },
    {
      name: "Customers Data",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={customer}
        ></img>
      ),
      route: "/customer-list",
    },
    {
      name: "Documents",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={documents}
        ></img>
      ),
      route: "/documents",
    },
    {
      isMulti: true,
      children: [
        { name: "Browser Notifications", route: "/browser-notif" },
        { name: "Email Notifications", route: "/email-notif" },
      ],
      name: "Notifications",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={notification}
        ></img>
      ),
      route: "/notifications",
    },

    {
      name: "Branding",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={brand}
        ></img>
      ),
      route: "/branding",
    },
    {
      name: "Social Media",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={socialMedia}
        ></img>
      ),
      route: "/social-media",
    },
  ],
  Merchant: [
    {
      name: "Dashboard",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={dashboard}
        ></img>
      ),
      route: "/dashboard",
    },
    {
      name: "Live Orders",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={live}
        ></img>
      ),
      route: "/liveorders",
    },
    {
      isMulti: true,
      name: "Branch",
      children: [
        { name: "Add Branch", route: "/branch/add/basic" },
        { name: "View Branch", route: "/view/branch" },
        { name: "Branch Bulk Upload", route: "/branch/bulk/upload" },
      ],
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={branch}
        ></img>
      ),
    },
    {
      name: "Products",
      children: [
        { name: "New Products", route: "/item/add" },
        { name: "View Products", route: "/view/menu" },
        { name: "Combo's", route: "/combo" },
        { name: "View Combo", route: "/view/combo" },
        { name: "Discount", route: "/discount" },
        { name: "View Discounts", route: "/view/discount" },
        { name: "Product Bulk upload", route: "/product/bulk/upload" },
      ],
      isMulti: true,
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={product}
        ></img>
      ),
    },
    {
      name: "Waiter Pannel",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={waiter}
        ></img>
      ),
      route: "/waiter/pannel/signup",
    },
    {
      name: "Qr",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={Qr}
        ></img>
      ),
      route: "/qr",
    },
    {
      name: "Order History",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={order}
        ></img>
      ),
      route: "/order-history",
    },
    {
      name: "Customers Data",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={customer}
        ></img>
      ),
      route: "/customer-list",
    },
    {
      name: "Documents",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={documents}
        ></img>
      ),
      route: "/documents",
    },
    {
      isMulti: true,
      children: [
        { name: "Browser Notifications", route: "/browser-notif" },
        { name: "Email Notifications", route: "/email-notif" },
      ],
      name: "Notifications",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={notification}
        ></img>
      ),
      route: "/notifications",
    },

    {
      name: "Branding",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={brand}
        ></img>
      ),
      route: "/branding",
    },
    {
      name: "Social Media",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={socialMedia}
        ></img>
      ),
      route: "/social-media",
    },
  ],
  Branch: [
    {
      name: "Dashboard",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={dashboard}
        ></img>
      ),
      route: "/dashboard",
    },
    {
      name: "Live Orders",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={live}
        ></img>
      ),
      route: "/liveorders",
    },
    {
      name: "Products",
      children: [
        { name: "New Products", route: "/item/add" },
        { name: "View Products", route: "/view/menu" },
        { name: "Combo's", route: "/combo" },
        { name: "View Combo", route: "/view/combo" },
        { name: "Discount", route: "/discount" },
        { name: "View Discounts", route: "/view/discount" },
        { name: "Product Bulk upload", route: "/product/bulk/upload" },
      ],
      isMulti: true,
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={product}
        ></img>
      ),
    },
    {
      name: "Waiter Pannel",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={waiter}
        ></img>
      ),
      route: "/waiter/pannel/signup",
    },
    {
      name: "Qr",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={Qr}
        ></img>
      ),
      route: "/qr",
    },
    {
      name: "Order History",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={order}
        ></img>
      ),
      route: "/order-history",
    },
    {
      name: "Customers Data",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={customer}
        ></img>
      ),
      route: "/customer-list",
    },
  ],
  Waiter: [
    {
      name: "Live Orders",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={live}
        ></img>
      ),
      route: "/liveorders",
    },
    {
      name: "Order History",
      icon: (
        <img
          style={{
            height: "21px",
            width: "21px",
          }}
          src={order}
        ></img>
      ),
      route: "/order-history",
    },
  ],
};
